import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getJobType = async (
  cleaner_id: any,
  id: any,
  page?: any,
  limit?: any,
  alldata?: any, //true
) => {
  const queryParams = new URLSearchParams();
  if (cleaner_id) queryParams.append("cleaner_id", cleaner_id.toString());
  if (page) queryParams.append("page", page?.toString());
  if (limit) queryParams.append("limit", limit?.toString());
  if (id) queryParams.append("id", id.toString());
  if (alldata) queryParams.append("alldata", alldata);
  try {
    return await get<ApiResponse<[]>>(`/cleaner/jobtypes?${queryParams}`).then(
      (res) => {
        if (res.success === true) {
          return res;
        } else {
          return null;
        }
      },
    );
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};
